if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add("sticky-atc-bar-enabled");

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };

        this.handleProductFormQuantityChange =
          this.handleProductFormQuantityChange.bind(this);
      }

      get quantityInput() {
        return this.querySelector("quantity-input input");
      }
      get quantity() {
        return this.querySelector("quantity-input");
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute("data-product-id");
      }
      get select() {
        return this.querySelector("select");
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityDiscountPicker() {
        return document.querySelector(
          ".product__blocks quantity-discount-picker",
        );
      }

      get priceDiscountElement() {
        return this.querySelector(".f-price-item.f-price-item--sale");
      }

      get priceUnitElement() {
        return this.querySelector(".f-price__unit span[data-unit-price]");
      }

      get discountSummary() {
        return this.querySelector(".sticky-atc-bar__discount");
      }

      get defaultPriceWrapper() {
        return this.querySelector(".sticky-atc-bar__product-info .f-price");
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          `.main-product-form[data-product-id="${this.productId}"]`,
        );
        this.mainProductInfo = document.querySelector(
          `product-info[data-product-id="${this.productId}"]`,
        );
        this.container = this.closest(".sticky-atc-bar");
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect,
        ).value;

        this.variantData = this.getVariantData();

        this.init();
        this.initDiscountSummary();
        this.select.addEventListener("change", (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects =
            this.mainProductInfo &&
            this.mainProductInfo.querySelector("variant-selects");
          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect,
          ).value;
          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId),
          );

          if (this.mainVariantSelects) {
            Array.from(
              this.mainVariantSelects.querySelectorAll("select, fieldset"),
              (element, index) => {
                const variantOptionVal = this.currentVariant.options[index];
                switch (element.tagName) {
                  case "SELECT":
                    element.value = variantOptionVal;
                    const options = element.querySelectorAll("option");
                    options.forEach((option) =>
                      option.removeAttribute("selected"),
                    );

                    element.value = variantOptionVal;
                    const selectedOption = element.querySelector(
                      `option[value="${variantOptionVal}"]`,
                    );
                    if (selectedOption) {
                      selectedOption.setAttribute("selected", "selected");
                    }
                    break;
                  case "FIELDSET":
                    Array.from(element.querySelectorAll("input")).forEach(
                      (radio) => {
                        if (radio.value === variantOptionVal) {
                          radio.checked = true;
                        }
                      },
                    );
                    break;
                }
              },
            );
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(
                new Event("change", { detail: { formStickty: true } }),
              );
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              FoxTheme.variantStrings.soldOut,
            );
          }
        });

        this.quantity.addEventListener("change", (e) => {
          const quantity = this.quantityInput.value;
          if (!this.quantityDiscountPicker || !quantity) {
            return;
          }

          this.updateDiscountSummary(quantity);

          const discountPrices =
            this.quantityDiscountPicker.getProductDiscountPricesByQuantity(
              quantity,
            );
          if (!discountPrices) {
            return;
          }
          const { priceWrapper, salePrice, compareAtPrice, unitPrice } =
            FoxTheme.utils.queryDomNodes(
              {
                priceWrapper: ".f-price",
                salePrice: ".f-price-item--sale",
                compareAtPrice: [".f-price-item--regular"],
                unitPrice: ".f-price__unit span[data-unit-price]",
              },
              this,
            );

          if (discountPrices.discountPrice !== discountPrices.originalPrice) {
            priceWrapper?.classList.add("f-price--on-sale");
            HTMLUpdateUtility.setInnerHTML(
              salePrice,
              discountPrices.discountPrice,
            );
            HTMLUpdateUtility.setInnerHTML(unitPrice, discountPrices.unitPrice);
            compareAtPrice?.forEach((item) =>
              HTMLUpdateUtility.setInnerHTML(
                item,
                `<s>${discountPrices.originalPrice}</s>`,
              ),
            );
            return;
          }
          priceWrapper?.classList.remove("f-price--on-sale");
          compareAtPrice?.forEach((item) =>
            HTMLUpdateUtility.setInnerHTML(item, discountPrices.discountPrice),
          );
        });

        document.addEventListener(
          "pdp:quantity-change",
          this.handleProductFormQuantityChange,
        );

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.submitButton.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener(
          "pdp:quantity-change",
          this.handleProductFormQuantityChange,
        );
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll(
          "[data-custom-property]",
        );
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(this.selectedVariantId),
        );
        fetch(
          `${this.getAttribute("data-url")}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`,
            );
            const newQuantity = parsedHTML.querySelector(
              `#QuantitySticky-${this.sectionId}`,
            );
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector('[type="application/json"]')
              .textContent,
          );
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add("sticky-atc-bar--show");
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? "add" : "remove";
              this.container.classList[method]("sticky-atc-bar--show");
            });
          },
          { threshold: 1, rootMargin },
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty(
          "--sticky-atc-bar-height",
          this.clientHeight + "px",
        );
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector("#product-form-sticky-atc-bar");
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector("span");
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: "f-price--on-sale",
          soldOut: "f-price--sold-out",
        };
        const selectors = {
          priceWrapper: ".f-price",
          salePrice: ".f-price-item--sale",
          compareAtPrice: [".f-price-item--regular"],
          unitPriceWrapper: ".f-price__unit-wrapper",
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } =
          FoxTheme.utils.queryDomNodes(selectors, this);
        const unitPrice = unitPriceWrapper.querySelector(".f-price__unit");

        const { compare_at_price, price, unit_price_measurement } =
          this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice)
          salePrice.innerHTML = FoxTheme.Currency.formatMoney(
            price,
            moneyFormat,
          );

        if (
          compareAtPrice &&
          compareAtPrice.length &&
          compare_at_price > price
        ) {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML = FoxTheme.Currency.formatMoney(
                compare_at_price,
                moneyFormat,
              )),
          );
        } else {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML = FoxTheme.Currency.formatMoney(
                price,
                moneyFormat,
              )),
          );
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove("hidden");
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat,
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add("hidden");
        }

        this.updateDiscountSummary(this.quantityInput?.value);
      }

      initDiscountSummary() {
        const picker = this.quantityDiscountPicker;
        const summary = this.discountSummary;
        if (!picker || !summary) return;

        this.discountSummaryActive = true;

        // Inherit the merchant's picker colors so the pill/badge/price match.
        const pickerStyles = getComputedStyle(picker);
        [
          "--qdp-discount-badge-bg",
          "--qdp-discount-badge-color",
          "--qdp-discounted-price-color",
          "--qdp-option-text-bg",
          "--qdp-option-text-color",
        ].forEach((varName) => {
          const value = pickerStyles.getPropertyValue(varName).trim();
          if (value) summary.style.setProperty(varName, value);
        });

        // Populate before revealing so the summary never paints empty.
        this.updateDiscountSummary(this.quantityInput?.value);

        // If the picker hasn't been upgraded yet (script order), its tier
        // lookup isn't available — repopulate once it is defined.
        if (typeof picker.getProductDiscountPricesByQuantity !== "function") {
          customElements
            .whenDefined("quantity-discount-picker")
            .then(() => this.updateDiscountSummary(this.quantityInput?.value));
        }

        // Swap the plain price for the quantity-aware discount summary.
        // Use the `.hidden` utility (not the `hidden` attr) so it beats
        // `.f-price { display: inline-flex }` on specificity/source order.
        const defaultPrice = this.defaultPriceWrapper;
        if (defaultPrice) defaultPrice.classList.add("hidden");
        summary.hidden = false;
      }

      updateDiscountSummary(quantity) {
        if (!this.discountSummaryActive) return;
        const picker = this.quantityDiscountPicker;
        const summary = this.discountSummary;
        if (!picker || !summary) return;

        const qty = Math.max(1, parseInt(quantity, 10) || 1);
        const info =
          typeof picker.getProductDiscountPricesByQuantity === "function"
            ? picker.getProductDiscountPricesByQuantity(qty)
            : null;

        const discount = info ? info.discount : 0;
        const plainPrice = Number(picker.dataset.plainPrice) || 0;
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const multiplier = 1 - discount / 100;

        // Discounts are rounded up per unit, then multiplied — matches the picker.
        const perUnit = Math.ceil(plainPrice * multiplier);
        const totalFinal = perUnit * qty;
        const totalCompare = plainPrice * qty;
        const onSale = discount > 0;

        const format = (cents) =>
          FoxTheme.Currency.formatMoney(cents, moneyFormat);

        const nodes = FoxTheme.utils.queryDomNodes(
          {
            qtyText: "[data-sticky-qty-text]",
            badge: "[data-sticky-discount-badge]",
            discountValue: "[data-sticky-discount-value]",
            compare: "[data-sticky-compare]",
            compareValue: "[data-sticky-compare] strike",
            final: "[data-sticky-final]",
          },
          summary,
        );

        // Reuse the matching tier's label (e.g. "3 Packungen") like the picker.
        if (nodes.qtyText)
          nodes.qtyText.textContent = (info && info.text) || String(qty);

        if (nodes.badge) {
          nodes.badge.hidden = !onSale;
          if (nodes.discountValue)
            nodes.discountValue.textContent = `-${discount}%`;
        }

        if (nodes.final) {
          nodes.final.textContent = format(totalFinal);
          nodes.final.classList.toggle("on-sale", onSale);
        }

        if (nodes.compare) {
          nodes.compare.hidden = !onSale;
          if (nodes.compareValue)
            nodes.compareValue.textContent = format(totalCompare);
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            const isMainProduct =
              event.data.sectionId === this.mainProductInfo.dataset.section;
            if (!isMainProduct) return;
            const variant = event.data.variant;
            const variantInput = this.querySelector('[name="id"]');

            this.currentVariant = variant;
            variantInput.value = variant.id;
            this.updatePrice();
            this.updateButton(true, "", false);
            if (!variant) {
              this.updateButton(true, "", true);
            } else {
              this.updateButton(
                !variant.available,
                FoxTheme.variantStrings.soldOut,
              );
            }

            this.updateQuantityInput();
          },
        );
      }

      handleProductFormQuantityChange(e) {
        const quantity = e.detail?.quantity;
        if (!quantity || !this.quantityInput) return;
        if (this.quantityInput.value === String(quantity)) return;

        this.quantityInput.value = quantity;
        this.quantityInput.dispatchEvent(
          new Event("change", { bubbles: true }),
        );
      }
    },
  );
}
